import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { openPaymentLink } from "./billing/paddle";
import { appConfig } from "./config";

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

// Before the router can touch the address: a Paddle payment link is `/?_ptxn=…`.
if (appConfig) openPaymentLink(appConfig, window.location.search);

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
